(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  class AdvancedMarquee {
    constructor(element) {
      this.element = element;
      this.speed = parseInt(element.dataset.speed);
      this.direction = element.dataset.direction;
      this.pauseOnHover = element.dataset.pauseOnHover === 'true';
      this.gap = parseInt(element.dataset.gap);
      
      this.init();
    }

    init() {
      // Set the CSS variable for animation speed
      this.element.style.setProperty('--scroll-speed', `${this.speed}s`);
      
      // Set direction attribute
      this.element.setAttribute('data-direction', this.direction);
      this.element.setAttribute('data-pause-on-hover', this.pauseOnHover);
      
      // Force hardware acceleration
      this.element.style.transform = 'translateZ(0)';
      
      // Ensure animation runs
      this.element.style.animationPlayState = 'running';
      
      // Check if we need to duplicate more for infinite scroll
      this.ensureInfiniteScroll();
    }
    
    ensureInfiniteScroll() {
      // Get total width of content
      const track = this.element;
      const items = track.querySelectorAll('.advanced-marquee__item:not(.advanced-marquee__item--clone)');
      const totalWidth = track.scrollWidth;
      const containerWidth = this.element.parentElement.parentElement.clientWidth;
      
      // If content is less than 2x container width, add more clones
      if (totalWidth < containerWidth * 2) {
        const clonesNeeded = Math.ceil((containerWidth * 2) / totalWidth);
        const originalItems = Array.from(items);
        
        for (let i = 0; i < clonesNeeded; i++) {
          originalItems.forEach(item => {
            const clone = item.cloneNode(true);
            clone.classList.add('advanced-marquee__item--clone');
            clone.setAttribute('aria-hidden', 'true');
            track.appendChild(clone);
          });
        }
      }
    }
  }

  // Initialize all marquees when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    const marquees = document.querySelectorAll('.advanced-marquee__content');
    marquees.forEach(function(marquee) {
      new AdvancedMarquee(marquee);
    });
  });
  
  // Re-initialize on window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      const marquees = document.querySelectorAll('.advanced-marquee__content');
      marquees.forEach(function(marquee) {
        // Reset animation to prevent jumps
        marquee.style.animation = 'none';
        marquee.offsetHeight; // Force reflow
        marquee.style.animation = '';
        
        // Re-initialize
        new AdvancedMarquee(marquee);
      });
    }, 250);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
